import { queryOptions } from '@tanstack/react-query';

import type { NewsPageData } from './get-news-page-data.ts';
import { getNewsPageData } from './get-news-page-data.ts';

export const NEWS_PAGE_QUERY_KEY = ['news-page'] as const;

interface GetNewsPageDataQueryOptionsInput {
	readonly company?: string;
	readonly type?: 'all' | 'interest';
}

export function getNewsPageQueryKey({ company, type }: GetNewsPageDataQueryOptionsInput) {
	return [...NEWS_PAGE_QUERY_KEY, company ?? null, type ?? 'all'] as const;
}

export function getNewsPageDataQueryOptions({ company, type }: GetNewsPageDataQueryOptionsInput) {
	return queryOptions<NewsPageData>({
		queryFn: () => getNewsPageData({ data: { company, type } }),
		queryKey: getNewsPageQueryKey({ company, type }),
	});
}
